import type { ListEnumOptionsSource } from '@/shared/ui/list-page';
import type { EnumOption } from './placeholderEnums';

/**
 * Zdroj options enum filtru ListPage ze statického (lokalizovaného) seznamu voleb — na rozdíl od
 * číselníkových filtrů nepotřebuje API dotaz. Enum hodnoty (string, `value == name`) jdou do filtru
 * jako `ids`, což odpovídá BE `EnumFilter`.
 */
export function staticEnumOptions(options: EnumOption[]): ListEnumOptionsSource {
  return {
    useOptions() {
      return {
        options: options.map((option) => ({ id: option.value, label: option.label })),
        isLoading: false,
      };
    },
  };
}
